import * as React from "react";
import { SVGProps } from "react";
const SvgLogoJira = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-jira_svg__a)">
      <path
        d="M17.039 8.68 9.366.935l-.743-.75-5.776 5.83L.206 8.68a.718.718 0 0 0 0 1.008l5.277 5.327 3.14 3.17 5.775-5.832.09-.09 2.55-2.571a.713.713 0 0 0 .155-.78.713.713 0 0 0-.154-.232Zm-8.416 3.165-2.637-2.66 2.637-2.662 2.635 2.661-2.635 2.662Z"
        fill="#2684FF"
      />
      <path
        d="M8.623 6.523a4.502 4.502 0 0 1-1.3-3.155A4.502 4.502 0 0 1 8.603.206L2.836 6.027l3.14 3.17 2.648-2.674Z"
        fill="url(#logo-jira_svg__b)"
      />
      <path
        d="m11.265 9.177-2.642 2.669c.832.84 1.3 1.98 1.3 3.168a4.503 4.503 0 0 1-1.3 3.169l5.784-5.837-3.142-3.169Z"
        fill="url(#logo-jira_svg__c)"
      />
    </g>
    <defs>
      <linearGradient
        id="logo-jira_svg__b"
        x1={8.151}
        y1={3.83}
        x2={4.434}
        y2={7.511}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.18} stopColor="#0052CC" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="logo-jira_svg__c"
        x1={671.806}
        y1={781.589}
        x2={1049.82}
        y2={1024.34}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.18} stopColor="#0052CC" />
        <stop offset={1} stopColor="#2684FF" />
      </linearGradient>
      <clipPath id="logo-jira_svg__a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoJira;
